import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import TopicListBanner from "./TopicListBanner/TopicListBanner";
import ReactTable from "./ReactTable";
import { LANGUAGE_ENGLISH, TRANSLATION } from "../VocabularyCenter/optionConstants";
import DialogView from "./DialogContents";
import {
  getVocabularyContents,
  getVocabularySearchedWord,
  getVocabularyWordList,
} from "../../../redux/actions/vocabularyCenterAction";
import { NON_CASE_SENSITIVE, USER } from "../../../redux/constants";
import InfoDetails from "./InfoDetails";
import { removeSpecialCharacters, getSearchedWordDetails } from "./VocabularyCenterPOCUtils";
import { useAddWordListDialog } from "./useAddWordList";

const TopicWordList = () => {

  const navigate = useNavigate();
  const prams = useParams();
  const dispatch = useDispatch();
  const { peopleInformation, common, vocabularyContents } = useSelector((state: any) => state);
  const [searchText, setSearchText] = useState<string>("");
  const [topicWordLists, setTopicWordLists] = useState<any>({});
  const [showInfoDetails, setShowInfoDetails] = React.useState<boolean>(false);
  const [addNewWord, setAddNewWord] = React.useState<boolean>(false);
  const [infoDetails, setInfoDetails] = React.useState<any>({});
  const [isUserWordList, setIsUserWordList] = React.useState<boolean>(false);
  const addWordListDialog = useAddWordListDialog();

  useEffect(() => {
    if (
      vocabularyContents?.headerLevelContents &&
      typeof vocabularyContents.headerLevelContents === "object" &&
      Object.keys(vocabularyContents.headerLevelContents).length > 0
    ) {
      const selectedTopicListData = vocabularyContents.topicsListData?.find(
        (topic: any) => topic.topic === prams.topic,
      );
      setIsUserWordList(selectedTopicListData?.isUserWordList);
      const selectedTopicWordList = selectedTopicListData?.listDetails?.find(
        (list: any) => list.listId == prams.subTopic,
      );
      if (selectedTopicWordList) {
        setTopicWordLists(selectedTopicWordList);
      }
    } else if (peopleInformation?.data && common?.lgId) {
      const { token, accountId } = peopleInformation.data.getpeopleInformation;
      dispatch(getVocabularyContents(common.lgId, token, parseInt(accountId, 10)));
    }
  }, [peopleInformation, vocabularyContents?.headerLevelContents]);

  useMemo(() => {
    if (peopleInformation?.data && common?.lgId) {
      dispatch(
        getVocabularyWordList(
          common.lgId,
          peopleInformation.data.getpeopleInformation.token,
          prams.subTopic ?? "",
          TRANSLATION,
          LANGUAGE_ENGLISH,
        ),
      );
    }
  }, [vocabularyContents?.headerLevelContents, prams.subTopic]);

  useEffect(() => {
    if (infoDetails && Object.keys(infoDetails).length > 0) {
      setShowInfoDetails(true);
    }
  }, [infoDetails]);
  const handleSearch = (e: any) => {
    if (
      (e?.key?.toUpperCase() === "ENTER" && searchText.length > 0) ||
      (e?.target?.id === "search-button" && searchText.length > 0)
    ) {
      setShowInfoDetails(true);
      dispatch(
        getVocabularySearchedWord(
          common.lgId,
          peopleInformation.data.getpeopleInformation.token,
          searchText,
          USER,
          NON_CASE_SENSITIVE,
        ),
      );
    }
  };
  return (
    <div className="new-vocabulary-center-container" data-testid="TopicWordList">
      <TopicListBanner
        topicName={removeSpecialCharacters(prams.topic)}
        searchText={searchText}
        setSearchText={setSearchText}
        changeClassName={"change-view"}
        showWordLists={true}
        handleSearch={handleSearch}
        isNotVocabCenterPage={true}
        searchOnly={false}
      />

      <div className="word-list-container">
        <ReactTable
          searchText={searchText}
          breadcrumbTitle={removeSpecialCharacters(prams.topic)}
          setInfoDetails={setInfoDetails}
          isUserWordList={isUserWordList}
          showingWordListDetails={topicWordLists}
          setShowWords={addWordListDialog.closeDialog}
          changeView={() => {
            navigate(`/vocabularycenter/${prams.topic}`);
          }}
          mainView={() => navigate(`/vocabularycenter`)}
          openAddWordDialog={setShowInfoDetails}
          setAddNewWord={setAddNewWord}
        />

        <DialogView
          open={addWordListDialog.isOpen}
          handleClose={addWordListDialog.closeDialog}
          dialogContainerClassNameValue="vocabulary-show-add-wordlist-popup"
          dialogContentsClassName="vocabulary-show-add-wordlist-contents"
          dialogBody={addWordListDialog.getAddWordList()}
        />
        <DialogView
          open={showInfoDetails}
          handleClose={() => {
            setShowInfoDetails(false);
            setSearchText("");
            setInfoDetails({});
          }}
          dialogContainerClassNameValue="vocabulary-show-info-details-popup"
          dialogContentsClassName="vocabulary-show-info-details-contents"
          dialogBody={
            <InfoDetails
              handleClose={() => {
                setShowInfoDetails(false);
                setSearchText("");
                setInfoDetails({});
              }}
              infoDetails={getSearchedWordDetails(infoDetails)}
              newWordTitle={searchText}
              openAddWordListDialog={addWordListDialog.openDialog}
              addNewWord={addNewWord}
              setAddNewWord={setAddNewWord}
              openInfoDialog={setShowInfoDetails}
              showingWordListDetails={topicWordLists}
            />
          }
        />
      </div>
    </div>
  );
};
export default TopicWordList;
